<template>
  <div
    :class="['filter-row align-center', {'disabled' : disabled, 'is-not-use-mode': num == 0 || !withMode}]"
    :data-qa="'filter-row-' + num"
    @click.capture="validateRow">
    <sSelect
      v-if="num != 0 && withMode"
      class="filter-row__filters"
      data-qa="select-contain_mode-for-all"
      :readonly="disabled"
      transparent
      :value.sync="contain_mode">
      <sOption
        v-for="necessarily_mode in necessarily_modes"
        :key="`option-${necessarily_mode.value}`"
        class="h11-links"
        :data-qa="`option-${necessarily_mode.value}`"
        :label="necessarily_mode.text"
        :value="necessarily_mode.value"/>
    </sSelect>
    <slot
      :disabled="disabled"
      :item="item"
      name="type">
      <sSelect
        class="filter-row__filters"
        data-qa="select-item"
        :readonly="disabled"
        transparent
        :value.sync="itemId">
        <sOption
          v-for="elementItem in itemsOrdered"
          :key="`option-${elementItem.id}`"
          class="h11-links"
          :data-qa="`option-${elementItem.id}`"
          :label="elementItem.title"
          :value="elementItem.id"/>
      </sSelect>
    </slot>
    <slot
      :disabled="disabled"
      :item="item"
      name="contain">
      <sSelect
        class="filter-row__filters"
        data-qa="select-item-contain_mode"
        :readonly="disabled"
        transparent
        :value.sync="containId">
        <sOption
          v-for="containMode in contain_modes"
          :key="`option-${containMode.value}`"
          class="h11-links"
          :data-qa="`option-${containMode.value}`"
          :label="containMode.text"
          :value="containMode.value"/>
      </sSelect>
    </slot>
    <div class="filter-row__value">
      <slot
        :disabled="disabled"
        :item="item"
        name="activator"/>
    </div>
    <sButton
      data-qa="btn-delete-template"
      :disabled="disabled"
      icon="delete"
      small
      type="text"
      @click="$emit('cancel', elem)"/>
  </div>
</template>

<script>
export default {
  name: 'FilterRowNew',
  data() {
    return {
      necessarily_modes: [
        {text: this.$t('Common.Also').toLocaleUpperCase(), value: true},
        {text: this.$t('Common.Or').toLocaleUpperCase(), value: false},
      ],
      contain_modes: [
        {text: this.$t('Common.Contains').toLocaleUpperCase(), value: true},
        {text: this.$t('Common.NotContains').toLocaleUpperCase(), value: false},
      ]
    }
  },
  props: {
    items: Array,
    elem: Object,
    num: Number,
    mode: Boolean,
    disabled: Boolean,
    withMode: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    itemsOrdered() {
      return [...this.items ?? []]
        .map(el => {
          return {
            id: el.id,
            title: el.title.toUpperCase()
          }
        })
        .sort((a, b) => a.id - b.id)
    },
    containId: {
      get() {
        return this.item?.contain
      },
      set(value) {
        const selectedItem = this.contain_modes.find(el => el.value === value)
        if (!selectedItem) {
          return
        }
        const result = { ...this.item, contain: selectedItem.value }
        this.$emit('update:elem', result)
        this.$emit('change-contain-mode', selectedItem, this.item.contain)
      }
    },
    itemId: {
      get() {
        return this.item?.id
      },
      set(value) {
        const selectedItem = this.items.find(el => el.id === value)

        this.$emit('update:elem', selectedItem)
        this.$emit('change-type', selectedItem, this.elem)
      }
    },
    item: {
      get() {
        return this.elem
      },
      set(value) {
        this.$emit('update:elem', value)
      }
    },
    contain_mode: {
      get() {
        return this.mode
      },
      set(value) {
        this.$emit('update:mode', value)
      }
    },
  },
  methods: {
    validateRow(event) {
      if (this.disabled) {
        event.stopPropagation()
      }
    }
  }
}
</script>

<style lang="scss">
.filter-row {
  display: grid;
  gap: 5px;
  grid-template-columns: 65px auto 125px 210px 30px;
  &.is-not-use-mode {
    grid-template-columns: auto 125px 210px 30px;
  }
  &.disabled {
    * {
      cursor: default;
    }
  }
  .filter-row__filters {
    flex-grow: 0;
    .s-input__inner {
      font-weight: 500 !important;
      font-size: 12px !important;
    }
  }
}
</style>
